import * as React from 'react';
import { Navigation } from './index';

const Footer: React.StatelessComponent = () => {
  return (
    <footer>
      <Navigation />
    </footer>
  );
};

export default Footer;
